export const CONSENT_CODE_PREFIX_BASE_QUERY_KEY = 'consent-code-prefix';

export const consentCodePrefixApiQueryKeys = {
  all: () => [CONSENT_CODE_PREFIX_BASE_QUERY_KEY] as const,
};
